import { useDroppable } from '@dnd-kit/core'
import AuthService from 'services/auth'
import { Container, InfoText } from './styles'

export default function TimeBlock ({
  id,
  professional,
  timeInterval,
  numColumns,
  positionx,
  positiony,
  label,
  onClick: handleClick
}) {
  const hasEditPermission = AuthService.hasPermission ('agenda', 'edit')
  const {isOver, setNodeRef} = useDroppable ({
    id,
    data: {
      time: label,
      professional
    }
  })

  return (
    <Container
      ref={setNodeRef}
      isDraggingOver={isOver}
      numColumns={numColumns}
      timeInterval={timeInterval}
      professional={professional}
      positionx={positionx}
      positiony={positiony}
      onClick={handleClick}
      disabled={!hasEditPermission}
    >
      <InfoText>
        {label}
      </InfoText>
    </Container>
  )
}